import { createSelector } from 'reselect';

const selectBlogPostFiles = (state: any) => state.blogPostsFiles;


export const selectBlogPostFilesCurrentItem = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.current);

export const selectBlogPostFilesListItems = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.list);

export const selectBlogPostFilesItemById = (itemId: any) =>
    createSelector(selectBlogPostFilesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBlogPostFilesQueryItem = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.query);

export const selectBlogPostFilesCreatedItem = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.create);

export const selectBlogPostFilesUpdatedItem = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.update);

export const selectBlogPostFilesReadItem = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.read);

export const selectBlogPostFilesDeletedItem = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.delete);

export const selectBlogPostFilesSearchedItems = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.search);

export const selectBlogPostFilesItemsCount = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.count);

export const selectBlogPostFilesItemsFilter = createSelector([selectBlogPostFiles], (blogPostsFiles) => blogPostsFiles.filter);